module.exports = __webpack_public_path__ + "img/czjl.34dbd563.png";